import BackgroundColor from "%/dynamic-component-editor/options/background-color";

export default class InputBackgroundColor extends BackgroundColor {
  static userInterfaceComponent = {
    ...BackgroundColor.userInterfaceComponent,
    label: "Input Background Color",
  };
}
